module.exports = __webpack_public_path__ + "coin_TON.svg?198aeeb8ef4406cf3654cd6d28d007ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_TON.svg
// module id = 1140
// module chunks = 2